

import 'vue-demi';
import Vue from 'vue';
import { PiniaVuePlugin } from 'pinia';
import VueCompositionAPI from '@vue/composition-api';
import IssueDetailWarper from './components/drawer';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);

export { IssueDetailWarper };
